module.exports = __webpack_public_path__ + "img/pic_4.44fc770c.png";